import CL from './CardsList'
import C from './Card'

export const Card = C
export const CardsList = CL
